<template>
	<section :class="['hotel-description-grid', hotelDescriptionClasses]">
		<div class="hotel-description-grid__left">
			<HotelDescriptionItem
				v-for="description in chunks.at(0)"
				:key="description.title"
				v-bind="description"
			/>
			<HotelInfoDisclaimer v-if="!hasMoreThanOneElement" />
		</div>
		<div class="hotel-description-grid__right">
			<HotelDescriptionItem
				v-for="description in chunks.at(1)"
				:key="description.title"
				v-bind="description"
			/>
			<HotelInfoDisclaimer v-if="hasMoreThanOneElement" />
		</div>
	</section>
</template>
<script lang="ts" setup>
import { descriptionToItemProps } from '@lmt-rpb/HotelDescriptionItem/helpers';
import { computed } from 'vue';
import HotelDescriptionItem from '@lmt-rpb/HotelDescriptionItem/HotelDescriptionItem.vue';
import HotelInfoDisclaimer from '@lmt-rpb/Atoms/HotelInfoDisclaimer/HotelInfoDisclaimer.vue';
import type { Description } from '@/interfaces/offer-list-types/offer-list-typo-hotel-data';
import { chunkArray } from '@/js/utils/arrayUtils';

interface Props {
	descriptions: Description[];
	columnDirection?: boolean;
}
const props = withDefaults(defineProps<Props>(), {
	descriptions: () => [],
	columnDirection: false,
});

const hotelDescriptionClasses = computed(() => ({
	'hotel-description-grid--column': props.columnDirection,
}));

const hasMoreThanOneElement = computed(() => props.descriptions.length > 1);

const mappedDescriptions = computed(() => props.descriptions.map((description) => descriptionToItemProps(description)));
const chunks = computed(() => chunkArray(mappedDescriptions.value, 2));

</script>

<style lang="scss" scoped>
.hotel-description-grid {
	display: grid;
	gap: 2.4rem;
	grid-template-columns: 1fr;

	&__left,
	&__right {
		display: flex;
		flex-direction: column;
		align-items: flex-start;
		gap: 2.4rem;
	}

	&--column {
		gap: 1.6rem;

		& > .hotel-description-grid__left,
		& > .hotel-description-grid__right {
			gap: 1.6rem;
		}

	}

	@media screen and (min-width: $breakpoint-small) {
		&:not(&--column) {
			grid-template-columns: 1fr 1fr;
		}
	}
}
</style>
